import { Ellipse } from './Ellipse'
import { Text } from './Text'
import { Position } from './Position'
import { SocialMedia } from './SocialMedia'

export const Button = { Ellipse, Text, Position, SocialMedia}
